<template>
  <vx-card no-shadow>

    <ValidationObserver ref="form" v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(onClickSubmit)" autocomplete="off">

        <span class="label"> Acceptability for use in following markets:</span>

        <div class="vx-row mb-3 mt-4">
          <div class="vx-col md:w-1/2 md:mb-0">
            <ValidationProvider vid="is_eu" name="is_eu" rules=""
                                v-slot="{ errors }">
              <small class="label">EU ?</small>
              <vs-switch v-model="form.is_eu" icon-pack="feather" vs-icon-on="icon-check-circle"
                         vs-icon-off="icon-slash" class="mt-2 w-16">
                <span slot="on">Yes</span>
                <span slot="off">No</span>
              </vs-switch>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-1/2 w-full md:mb-0">
            <ValidationProvider v-if="form.is_eu" vid="is_eu_comment" name="is_eu_comment"
                                rules="" v-slot="{ errors }">
              <small class="label">Comment</small>
              <vs-input type="text" v-model="form.is_eu_comment" name="is_eu_comment" class="w-full" :danger="errors[0]" :danger-text="errors[0]"
                        val-icon-danger="icon-x" val-icon-pack="feather"/>
            </ValidationProvider>
          </div>
        </div>


        <div class="vx-row mb-3">
          <div class="vx-col md:w-1/2 md:mb-0">
            <ValidationProvider vid="is_usa" name="is_usa" rules="required" v-slot="{ errors }">
              <small class="label">USA?</small>
              <v-select label="name" :reduce="option => option.value" name="is_usa" :closeOnSelect="true"
                        v-model="form.is_usa"
                        :options="[{name: 'YES', value: 0}, {name: 'NO', value: 1}, {name: 'UNKNOWN', value: 2}]"
                        :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
              <span class="text-danger text-sm">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
          <!--          <div class="vx-col md:w-1/2 w-full md:mb-0">-->
          <!--            <ValidationProvider v-if="form.is_usa === 0" vid="is_usa_comment" name="is_usa_comment" rules="required"-->
          <!--                                v-slot="{ errors }">-->
          <!--              <small class="label">Comment If Yes</small>-->
          <!--              <vs-input type="text" v-model="form.is_usa_comment" name="is_usa_comment" class="w-full" :danger="errors[0]" :danger-text="errors[0]"-->
          <!--                        val-icon-danger="icon-x" val-icon-pack="feather"/>-->
          <!--            </ValidationProvider>-->
          <!--          </div>-->
        </div>

        <div class="vx-row mb-3">
          <div class="vx-col md:w-1/2 md:mb-0">
            <ValidationProvider vid="is_canada" name="is_canada" rules="required" v-slot="{ errors }">
              <small class="label">Canada?</small>
              <v-select label="name" :reduce="option => option.value" name="is_canada" :closeOnSelect="true"
                        v-model="form.is_canada"
                        :options="[{name: 'YES', value: 0}, {name: 'NO', value: 1}, {name: 'UNKNOWN', value: 2}]"
                        :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
              <span class="text-danger text-sm">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
          <!--          <div class="vx-col md:w-1/2 w-full md:mb-0">-->
          <!--            <ValidationProvider v-if="form.is_canada === 0" vid="is_canada_comment" name="is_canada_comment" rules="required"-->
          <!--                                v-slot="{ errors }">-->
          <!--              <small class="label">Comment If Yes</small>-->
          <!--              <vs-input type="text" v-model="form.is_canada_comment" name="is_canada_comment" class="w-full" :danger="errors[0]" :danger-text="errors[0]"-->
          <!--                        val-icon-danger="icon-x" val-icon-pack="feather"/>-->
          <!--            </ValidationProvider>-->
          <!--          </div>-->
        </div>

        <div class="vx-row mb-3">
          <div class="vx-col md:w-1/2 md:mb-0">
            <ValidationProvider vid="is_japan" name="is_japan" rules="required" v-slot="{ errors }">
              <small class="label">Japan?</small>
              <v-select label="name" :reduce="option => option.value" name="is_japan" :closeOnSelect="true"
                        v-model="form.is_japan"
                        :options="[{name: 'YES', value: 0}, {name: 'NO', value: 1}, {name: 'UNKNOWN', value: 2}]"
                        :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
              <span class="text-danger text-sm">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
          <!--          <div class="vx-col md:w-1/2 w-full md:mb-0">-->
          <!--            <ValidationProvider v-if="form.is_japan === 0" vid="is_japan_comment" name="is_japan_comment" rules="required"-->
          <!--                                v-slot="{ errors }">-->
          <!--              <small class="label">Comment If Yes</small>-->
          <!--              <vs-input type="text" v-model="form.is_japan_comment" name="is_japan_comment" class="w-full" :danger="errors[0]" :danger-text="errors[0]"-->
          <!--                        val-icon-danger="icon-x" val-icon-pack="feather"/>-->
          <!--            </ValidationProvider>-->
          <!--          </div>-->
        </div>

        <div class="vx-row mb-3">
          <div class="vx-col md:w-1/2 md:mb-0">
            <ValidationProvider vid="is_other_country" name="is_other_country" rules=""
                                v-slot="{ errors }">
              <small class="label">Do you have other markets?</small>
              <vs-switch v-model="form.is_other_country" icon-pack="feather" vs-icon-on="icon-check-circle"
                         vs-icon-off="icon-slash" class="mt-2 w-16">
                <span slot="on">Yes</span>
                <span slot="off">No</span>
              </vs-switch>
            </ValidationProvider>
          </div>
        </div>


        <div v-if="form.is_other_country" v-for="(other, index) in form.other_country_item" :key="index">
          <div class="vx-row mb-3" >
            <div class="vx-col md:w-1/4 w-full md:mb-0">
              <ValidationProvider :vid="index+'other_name'" :name="index+'other_name'" rules="required" v-slot="{ errors }">
                <small class="label">Country Name</small>
                <vs-input v-model="other.name" type="text" name="name" class="w-full"  :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/4 md:mb-0">
              <ValidationProvider vid="acceptability" name="acceptability" rules="required" v-slot="{ errors }">
                <small class="label">Acceptability</small>
                <v-select label="name" :reduce="option => option.value" name="is_japan" :closeOnSelect="true"
                          v-model="other.acceptability"
                          :options="[{name: 'YES', value: 0}, {name: 'NO', value: 1}, {name: 'UNKNOWN', value: 2}]"
                          :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <!--            <div class="vx-col md:w-1/4 w-full md:mb-0">-->
            <!--              <ValidationProvider :vid="index+'comment'" :name="index+'comment'" rules="required" v-slot="{ errors }">-->
            <!--                <small class="label">Optional Comment If Yes</small>-->
            <!--                <vs-input v-model="other.comment" type="text" name="comment" class="w-full"  :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />-->
            <!--              </ValidationProvider>-->
            <!--            </div>-->
            <div class="vx-col md:w-1/4 w-full md:mb-0">
              <small class="label">&nbsp;</small>
              <vs-button :disabled="form.other_country_item.length === 1" class="" @click="deleteOtherName(index)" size="small" color="danger" type="filled" icon-pack="feather" icon="icon-x"></vs-button>
            </div>
          </div>
        </div>
        <vs-button v-if="form.is_other_country" @click="addOtherName" size="small" color="success" type="filled" icon-pack="feather" icon="icon-plus">Add Other Name</vs-button>

        <div class="flex flex-wrap items-center justify-end">
          <vs-button button="submit" class="ml-auto mt-2">Save and Change</vs-button>
          <vs-button v-if="!isCompleted" @click.stop="onClickMarkAsComplete" class="ml-4 mt-2" type="border" color="warning">Mark As Complete</vs-button>

        </div>
      </form>
    </ValidationObserver>
  </vx-card>

</template>

<script>
  import {RepositoryFactory} from '@/repository/RepositoryFactory'

  const SupplierManufactureRepository = RepositoryFactory.get('supplierManufacture');
  const SupplierRawMaterialRepository = RepositoryFactory.get('supplierRawMaterial')
  const SupplierRepository = RepositoryFactory.get('supplier');

  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import vSelect from "vue-select";
  import RawMaterialForm from "@/mixins/RawMaterialForm";


  export default {
    name: "SupplierManufacturingHome",
    data() {
      return {
        form: {
          is_eu: false,
          is_usa: null,
          is_canada: null,
          is_japan: null,
          other_country_item: [
            {name: '', acceptability: null, comment: ''}
          ],
          is_other_country: false
        },
        id: null,
        status: {},
      }
    },
    props : {
      isCompleted: { default: false },
    },
    mixins: [SuccessMessage, ErrorMessages, RawMaterialForm],
    components: {
      'v-select': vSelect,
    },
    methods: {
      onClickNext() {
        this.$emit('notify', 1)
      },
      async onClickMarkAsComplete() {
        this.$emit('mark-as-complete', 'is_raw_material_global_suitability_marked_completed')
      },
      onClickSubmit() {
        this.status.is_raw_material_global_suitability_complete ? this.$mixinsOpenUpdateConfirm() : this.onClickCreate()
      },
      async onClickUpdate() {
        this.$vs.loading();
        try {
          if (!this.form.is_other_country) {
            this.form.other_country_item = []
          }
          const data = (await SupplierRawMaterialRepository.UpdateRawMaterialGlobalSuitability(this.id, this.form));
          this.showSuccessMessage('Raw Material Global Suitability Details Updated!');
          this.onClickNext()
        } catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close()
      },
      async onClickCreate() {
        this.$vs.loading();
        try {
          if (!this.form.is_other_country) {
            this.form.other_country_item = []
          }
          const data = (await SupplierRawMaterialRepository.CreateRawMaterialGlobalSuitability(this.form));
          this.showSuccessMessage('Raw Material Global Suitability Details Updated!');
          this.onClickNext()
        } catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close()
      },

      async loadData() {
        this.$vs.loading();
        const {data} = (await SupplierRawMaterialRepository.getRawMaterialGlobalSuitability(this.id)).data;
        this.form = data;
        this.$vs.loading.close()
      },
      async loadStatus() {
        this.$vs.loading();
        const {data} = (await SupplierRawMaterialRepository.getRawMaterialStatus(this.id)).data;
        this.status = data;
        if (this.form.other_country_item.length === 0) {
          this.addOtherName()
        }
        this.$vs.loading.close()
      },
      addOtherName() {
        this.form.other_country_item.push(
          {name: '', acceptability: null, comment: ''}
        )
      },
      deleteOtherName(index) {
        this.form.other_country_item.splice(index, 1)
      }
    },
    async mounted() {
      this.id = this.$route.params.id
      this.form.supplier_raw_material_id =  this.id
      await this.loadStatus()
      if (this.status.is_raw_material_global_suitability_complete) {
        await this.loadData()
      }
    }

  }
</script>

<style scoped>

</style>
